<template>
	<div class="mProductCo">
		<div class="menuBox">
			<div class="menuImgBox" @click="open">
				<img class="menuImg" src="../../assets/mImg/menuIcon.png" alt="">
			</div>
			<div class="lansuImgBox">
				<img class="lansuImg" src="../../assets/logo2.png" alt="">
			</div>
			<!-- <div class="blackBox"></div> -->
		</div>
		<div class="firstBox">
			<!-- <img class="mFirst" src="../../assets/banner4.jpg"> -->
			<el-carousel v-if="this.brandId == 1" class="carouselMainBox" :height="bannerHeight+ 'px' " :interval="3000"
				arrow="always" autoplay>
				<el-carousel-item v-for="(item,index) in huaiImgBox" :key="index" class="carouselMainItem">
					<img ref="bannerHeight" @load="imgLoad" class="carouselImg" :src="item.img" alt="">
				</el-carousel-item>
			</el-carousel>

			<el-carousel v-if="this.brandId == 2" class="carouselMainBox" :height="bannerHeight+ 'px' " :interval="3000"
				arrow="always" autoplay>
				<el-carousel-item v-for="(item,index) in xinImgBox" :key="index" class="carouselMainItem">
					<img ref="bannerHeight" @load="imgLoad" class="carouselImg" :src="item.img" alt="">
				</el-carousel-item>
			</el-carousel>

			<el-carousel v-if="this.brandId == 3" class="carouselMainBox" :height="bannerHeight+ 'px' " :interval="3000"
				arrow="always" autoplay>
				<el-carousel-item v-for="(item,index) in yiImgBox" :key="index" class="carouselMainItem">
					<img ref="bannerHeight" @load="imgLoad" class="carouselImg" :src="item.img" alt="">
				</el-carousel-item>
			</el-carousel>

			<el-carousel v-if="this.brandId == 4" class="carouselMainBox" :height="bannerHeight+ 'px' " :interval="3000"
				arrow="always" autoplay>
				<el-carousel-item v-for="(item,index) in shuiImgBox" :key="index" class="carouselMainItem">
					<img ref="bannerHeight" @load="imgLoad" class="carouselImg" :src="item.img" alt="">
				</el-carousel-item>
			</el-carousel>

			<el-carousel v-if="this.brandId == 5" class="carouselMainBox" :height="bannerHeight+ 'px' " :interval="3000"
				arrow="always" autoplay>
				<el-carousel-item v-for="(item,index) in zhongImgBox" :key="index" class="carouselMainItem">
					<img ref="bannerHeight" @load="imgLoad" class="carouselImg" :src="item.img" alt="">
				</el-carousel-item>
			</el-carousel>

		</div>
		<el-drawer class="drawerBox" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
			unique-opened>
			<el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" @open="handleOpen"
				@close="handleCloseMenu" router>
				<el-menu-item index="/m">
					<i class="el-icon-s-home"></i>
					<span slot="title">首页</span>
				</el-menu-item>
				<el-menu-item index="/maboutLansu">
					<i class="el-icon-document"></i>
					<span slot="title">关于我们</span>
				</el-menu-item>
				<el-menu-item index="/mbrandLansu">
					<i class="el-icon-data-analysis"></i>
					<span slot="title">美业菩提</span>
				</el-menu-item>
				<el-menu-item index="/mDynamicLanshu">
					<i class="el-icon-star-off"></i>
					<span slot="title">菩提基金会</span>
				</el-menu-item>
				<el-submenu index="5">
					<template slot="title">
						<i class="el-icon-trophy"></i>
						<span>兰树品牌</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mhuaibrand">淮树</el-menu-item>
						<el-menu-item index="/mxinbrand">心清堂</el-menu-item>
						<el-menu-item index="/mshuibrand">水姻缘</el-menu-item>
						<el-menu-item index="/myibrand">一清堂</el-menu-item>
						<!-- <el-menu-item index="/mzhongbrand"><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span></el-menu-item> -->
						<el-menu-item index="/mlanshuBrand">兰树</el-menu-item>
						<el-menu-item index="/mzbqfBrand">植本清方</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item index="/mTrends">
					<i class="el-icon-bell"></i>
					<span slot="title">兰树动态</span>
				</el-menu-item>
			</el-menu>

		</el-drawer>

		<div class="mProductMain">
			<div class="productsMainTabs">
				<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
					<el-tab-pane v-for="(item,index) in seriesData" :key="index" :label="item.series_name"
						:name="'item'+index">
						<div class="mProductsItemMain">
							<div class="mProductsItemMiddle">
								<div class="mpItemsBox" v-for="(itemShopping,index) in productsData" :key="index">
									<div class="productsImgBox">
										<img class="productsImg" :src="itemShopping.thumbnail_url" alt="">
									</div>
									<div class="productsTitle">{{itemShopping.title}}</div>
									<div class="productsPrice">￥{{itemShopping.prize}}</div>
								</div>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>

			</div>
		</div>

		<div class="footerBoxMain">
			<div class="footerBoxMainMiddle">
				<div class="footerBoxTitle">快捷导航</div>
				<div class="bottomNavFirst bottomNav1">
					<div class="mHomeName">
						<router-link to="/m" tag="a">首页</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mDynamicLanshu" tag="a">菩提基金会</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav2">
					<div class="mHomeName">
						<router-link to="/maboutLansu" tag="a">关于兰树</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mhuaibrand" tag="a">兰树品牌</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav3">
					<div class="mHomeName">
						<router-link to="/mbrandLansu" tag="a">美业菩提</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mTrends" tag="a">兰树动态</router-link>
					</div>
				</div>
				<div class="footerBoxTitle footerBoxTitle2">联系我们</div>
				<div class="contactFirst contactFirst1">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/emailIcon.png" alt="">
					</div>
					<div class="contactContent">
						邮箱：postermaster@lasur.com
					</div>
				</div>
				<div class="contactFirst contactFirst2">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/phoneIcon.png" alt="">
					</div>
					<div class="contactContent">
						电话：0571-89025888
					</div>
				</div>
				<div class="contactFirst contactFirst3">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/gpsIcon.png" alt="">
					</div>
					<div class="contactContent">
						浙江省杭州市之江东路越秀·维多利中心A座 17楼
					</div>
				</div>
			</div>
			<div class="bottomLine"></div>
			<div class="codeBoxMain">
				<div class="footerBoxHeaderLeft">
					<img class="codeImg" src="../../assets/code.png" alt="">
					<span class="codeText">兰树公众号</span>
				</div>
				<div class="footerBoxHeaderRight">
					<img class="codeImg" src="../../assets/xcxNew.jpg" alt="">
					<span class="codeText">兰树云小程序</span>
				</div>
			</div>
			<div class="footerBoxBottom">
				<div class="footerLeft">
					Copyright © 2023 兰树化妆品股份有限公司
				</div>
				<div class="footerLeft">
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a><br />
					<img
						src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-13_13-29-23_21054.png" /><a
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
						33052102000740号</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { myGet, myPost, login } from "../../api/http.js";
export default {
	data() {
		return {
			drawer: false,
			direction: 'ltr',
			brandId: '',
			bannerHeight: '',
			activeName: 'item0',
			shoppingId: '',
			productsData: [],
			seriesid: '',
			seriesData: [],
			huaiImgBox: [
				{
					id: 1,
					img: require('../../assets/mImg/huai1.jpg')
				},
				{
					id: 2,
					img: require('../../assets/mImg/huai2.jpg')
				},
				{
					id: 3,
					img: require('../../assets/mImg/huai3.jpg')
				},
				{
					id: 4,
					img: require('../../assets/mImg/huai4.jpg')
				},
			],
			xinImgBox: [
				{
					id: 1,
					img: 'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_13-50-08_37831.jpg'
				},
				{
					id: 2,
					img: require('../../assets/mImg/xin2.jpg')
				},
				{
					id: 3,
					img: require('../../assets/mImg/xin3.jpg')
				},
				{
					id: 4,
					img: require('../../assets/mImg/xin4.jpg')
				}
			],
			yiImgBox: [
				{
					id: 1,
					img: require('../../assets/mImg/yi1.png')
				},
				{
					id: 2,
					img: require('../../assets/mImg/yi2.jpg')
				},
				{
					id: 3,
					img: require('../../assets/mImg/yi3.jpg')
				},
				{
					id: 4,
					img: require('../../assets/mImg/yi4.jpg')
				}
			],
			shuiImgBox: [
				{
					id: 1,
					img: require('../../assets/mImg/shui1.jpg')
				},
				{
					id: 2,
					img: require('../../assets/mImg/shui2.jpg')
				},
				{
					id: 3,
					img: require('../../assets/mImg/shui3.jpg')
				},
				{
					id: 4,
					img: require('../../assets/mImg/shui4.jpg')
				}
			],
			zhongImgBox: [
				{
					id: 1,
					img: require('../../assets/mImg/zhong1.jpeg')
				},
				{
					id: 2,
					img: require('../../assets/mImg/zhong2.jpeg')
				}
			]
		}
	},
	created() {
		this.getSeries();
		this.brandId = this.$route.query.brandId;
	},
	mounted() {
		this.imgLoad();
		window.addEventListener('resize', () => {
			this.bannerHeight = this.$refs.bannerHeight[0].height;
			this.imgLoad();
		}, false)
	},
	methods: {
		imgLoad() {
			console.log('brandId', this.brandId);
			this.$nextTick(() => {
				this.bannerHeight = this.$refs.bannerHeight[0].height;
				console.log(this.$refs.bannerHeight[0].height);
			})

		},
		handleClose(done) {
			done()
		},
		open() {
			this.drawer = true
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleCloseMenu(key, keyPath) {
			console.log(key, keyPath);
		},
		handleClick(tab, event) {
			let that = this;
			console.log(tab, event);
			console.log("www", tab.$el.id);
			let selId = tab.$el.id;
			for (let i = 0; i < that.seriesData.length; i++) {
				if (selId == 'pane-item' + i) {
					this.pageNum = 1;
					that.shoppingId = that.seriesData[i].id;
					that.getShopping(that.shoppingId);
				}
			}


		},
		//点击获取商品信息
		getShopping(opction) {
			console.log("opction", opction)
			this.seriesid = opction;
			myPost("api/goodslist/", {
				id: this.seriesid,
				pageNum: this.pageNum,
				pageSize: 12
			}).then((res) => {
				this.productsData = res.data.videolist;
				this.total = res.data.total_num;
			})

		},
		//获取品牌系列
		getSeries() {
			let that = this;
			myPost("api/serieslist/", {
				id: this.$route.query.brandId,
				// pageNum: this.pageNum,
				// pageSize:6,
			}).then((res) => {
				this.seriesData = res.data.videolist;
				this.getSeriesProducts(res.data.videolist[0].id);
				this.total = res.data.total_num;
			})
		},


		//获取系列商品
		getSeriesProducts(opaction) {
			console.log("1234", opaction);
			let seriesId = opaction;
			this.seriesid = seriesId;
			myPost("api/goodslist/", {
				id: seriesId,
				pageNum: this.pageNum,
				pageSize: 12
			}).then((res) => {
				this.productsData = res.data.videolist;
				this.total = res.data.total_num;

			})
		},

	}
}
</script>

<style scoped>
.mProductCo {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mFirst {
	width: 100%;
}

.mFirstBox {
	position: absolute;
	top: 0;
	z-index: 99;
}

.mFirstBoxMenu {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 999;
}

.mFirstBoxImgMenu {
	width: 50%;
	float: left;
	position: relative;
	left: 0.5rem;
}

.mFirstBoxImgBox {
	width: 100%;
	margin-top: 15%;
}


.mFirstBoxImg {
	width: 36%;
	float: right;
	margin-right: 20%;
}

.firstBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 3.5rem;
}


.carouselImg {
	width: 100%;
}

.carouselMainItem {
	width: 100%;
}

.carouselMainBox {
	width: 100%;
}

.mProductMain {
	display: flex;
	flex-direction: column;
	width: 100%;
	background: #F3F4F5;
	padding-top: 1rem;
	padding-bottom: 1rem;
}

.mProductsItemMain {
	width: 100%;
	background: #F3F4F5;
}

.mProductsItemMiddle {
	width: 90%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}

.mpItemsBox {
	width: 48%;
	display: flex;
	flex-direction: column;
	cursor: pointer;
	align-items: center;
	justify-content: center;
	transition: 0.3s ease;
	padding-bottom: 1rem;
	margin-top: 0.5rem;
	margin-left: 2%;
	background-color: #FFFFFF;
	overflow: hidden;
	border-radius: 6px;
}



.productsImgBox {
	width: 100%;
	margin: 0 auto;
	overflow: hidden;
}


.productsTitle {
	width: 80%;
	font-size: 0.9375em;
	font-weight: 400;
	color: #545454;
	line-height: 22px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}


.productsLine {
	width: 100%;
	height: 1px;
	background: #E4E4E4;
}

.productsPrice {
	width: 80%;
	font-size: 0.9375em;
	font-family: Helvetica;
	color: red;
	line-height: 22px;
	margin-top: 0.5em;
}

.productsImg {
	width: 100%;
}


.footerFirstLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 1rem;
}

.footerSecondLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 0.5rem;
}

.footerItem {
	list-style: none;
}

.footerItem a {
	color: #333333;
	font-size: 0.9375rem;
	text-decoration: none;
	margin-left: 0.5rem;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9375em;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
	margin-left: 1rem;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.9375rm;
	font-weight: 400;
	color: #222222;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerBoxHeader {
	width: 60%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}



.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.emailBox {
	font-size: 0.875rem;
	color: #222222;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
	text-align: center;
}

.footerLine {
	width: 100%;
	height: 1px;
	display: flex;
	background: #222222;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}


.footerBoxMainMiddle {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
}

.footerBoxTitle {
	color: #FFFFFF;
	font-size: 1rem;
	font-weight: 500;
}

.bottomNavFirst {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.mHomeName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.ptjjhName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.contactFirst {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.contactImgBox {
	width: 0.8rem;
}

.contactImg {
	width: 100%;
}

.contactContent {
	color: #FFFFFF;
	font-size: 0.7rem;
	opacity: 0.7;
	margin-left: 0.5rem;
}

.bottomLine {
	width: 100%;
	height: 2px;
	background: #FFFFFF;
	opacity: 0.1;
	margin-top: 1.5rem;
}

.footerBoxTitle2 {
	margin-top: 1.5rem;
}

.contactFirst1 {
	margin-top: 1rem;
}

.codeBoxMain {
	width: 50%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	margin-top: 1.5rem;
}


.codeImg {
	width: 80%;
}

.codeText {
	font-size: 0.5em;
	color: #FFFFFF;
	line-height: 20px;
	opacity: 0.7;
	/* margin-top: 0em; */
}

.footerBoxMain {
	width: 100%;
	background-color:  #2c5eff;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 1rem;
}

.footerLeft {
	text-align: center;
	font-size: 0.9em;
	color: #FFFFFF;
	line-height: 24px;
	opacity: 0.7;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #FFFFFF;
	opacity: 0.7;
}

.contactFirst2 {
	margin-top: 0.5rem;
}

.contactFirst3 {
	margin-top: 0.5rem;
}

/* 新导航栏 */
.menuBox {
	position: fixed;
	width: 100%;
	display: flex;
	top: 0;
	flex-direction: row;
	background: #FFFFFF;
	padding-top: 0.8rem;
	padding-bottom: 0.5rem;
	align-items: center;
	justify-content: space-between;
	z-index: 999;
}

.menuImgBox {
	width: 33.33%;
}

.menuImg {
	width: 17%;
	margin-left: 1rem;
}

.lansuImgBox {
	width: 40%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-right: 1rem;
}

.blackBox {
	width: 33.33%;

}

.lansuImg {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mComponents/mProductsList.vue